import React, { FC, useEffect, useState } from "react";
import { service } from "../../../services/AxiosServices";
import { useParams } from "react-router-dom";
import MainLayout from "../../Layouts/MainLayout";
import Spinner from "../atoms/Spinner";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";

//Knowledge holders
const KnowledgeHolders: FC = () => {
    const { id } = useParams();
    const [spaceUser, setSpaceUser] = useState<Array<{ id: number; email: string; first_name: string; last_name: string }>>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchSpaceUsers = async () => {
            try {
                setLoading(true);
                const response = await service<any>('/space-user-list-details', 'post', { space_id: id });
                setSpaceUser(response.data.response);
            } catch (err) {
                setError("Failed to fetch user data.");
            } finally {
                setLoading(false);
            }
        };
        fetchSpaceUsers();
    }, [id]);

    return (
        <MainLayout>
            <SectionHeader back={true} title="Knowledge holders"></SectionHeader>
            <WindowHeightComponent className={""}>
                <div className="p-3">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                            <Spinner />
                        </div>
                    ) : error ? (
                        <p className="text-danger text-center">{error}</p>
                    ) : (
                        <div className="Knowledge-holder-tils">
                            {spaceUser.map((user) => (
                                <div key={user.id} className="Knowledge-holder-cards d-flex align-items-center justify-content-center p-3">
                                    <div className="text-center">
                                        <div className="Holder-profile mb-2">
                                            <img src={`https://ui-avatars.com/api/?name=${user.first_name}+${user.last_name}&background=random`} alt={user.first_name} className="rounded-circle" />
                                        </div>
                                        <h5 className="Holder-name mb-3">{user.first_name} {user.last_name}</h5>
                                        <p className="Holder-email text-break">{user.email}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

            </WindowHeightComponent>
        </MainLayout>
    );
};

export default KnowledgeHolders;

<style>{`
    .avatar img {
        width: 60px;
        height: 60px;
    }
`}</style>
